import type { PageProps } from '@/types';

type Identity = Diagonal.Auth.Data.IdentityData;

export function hasPermissions(user: unknown): user is Identity {
  return (
    Boolean(user) &&
    typeof user === 'object' &&
    Array.isArray((user as Record<string, unknown>).$permission_ids) &&
    Array.isArray((user as Record<string, unknown>).$permission_slugs)
  );
}

export function hasPermission(
  user: PageProps['identity'],
  permission: Diagonal.Core.Enums.SystemPermission
): boolean {
  if (!hasPermissions(user)) {
    return false;
  }

  return user.$permission_slugs.includes(permission);
}
